import {
  AUTHORIZE_IN_OKTA,
  CHECK_OKTA_SESSION,
  CLEAN_UP,
  DELETE_OKTA_SESSION,
  GET_FACTORS,
  GET_QUESTION_STATUS,
  SIGN_IN,
  SKIP_FACTORS,
  CHECK_ENCDATA_TOKEN,
  ENC_DATA_SIGN_IN
} from "./Login/constants";
import {
  authorize,
  authorizeInOktaDirectly,
  cleanUp,
  getFactors,
  getQuestionStatus,
  encDataSignIn
} from "./Login/actions";
import { select } from "redux-saga/effects";
import { push } from "connected-react-router";
import * as LocalStoreService from "../LocalStoreService";
import { get, isEmpty, isFunction, eq } from "lodash";
import { CHANGE_PASSWORD } from "./ChangePassword/constants";
import { UPDATE_FACTOR } from "./UpdateContact/constants";
import {
  PASSCODE_SUBMIT,
  RECOVERY_PASSCODE_SUBMIT,
  RESEND_PASSWORD_RECOVERY_CODE
} from "./VerifyPasscode/constants";
import { SET_SECURITY_QUESTION } from "./SetupSecurityQuestion/constants";
import { FORGOT_PASSWORD } from "./ForgotPassword/constants";
import { VERIFY_TOKEN } from "./TokenVerification/constants";
import { SUBMIT_ANSWER } from "./VerifySecurityQuestion/constants";
import { RESET_PASSWORD } from "./CreateNewPassword/constants";
import { oktaErrorMessage } from "../utils/messageExtractor";
import { GET_LINKED_DMS } from "./FederatedDriveSSO/constants";
import isValidEmailForm from "../utils/validator";
import { MFA_SELECT } from "./MfaFactor/constants";
import {
  MFA_VERIFY_FACTOR,
  MFA_RESEND_CODE
} from "./VerifyMfaFactor/constants";
import { MFA_VERIFY_FACTOR_FIRST_TIME } from "./VerifyMfaFactorFirstTime/constants";
import { ENROLL_SPECIFIC_MFA } from "./EnrollSpecificMFA/constants";

const actionMap = new Map();
let isPasswordExpiredSelector = (state) =>
  get(state, "loginPage.isPasswordExpired");

export const factorsSelector = (state) => get(state, "loginPage.factors");
const factorStatusSelector = (state) => get(state, "loginPage.factorStatus");
const mfaEnrollFactors = (state) =>
  get(state, "enrollMFA.selectedMfaEnrollFactor");

const userSelector = (state) => get(state, "loginPage.authnResponse", "");

const isQuestionSetup = (response) => {
  const responseQuestion = get(response, "recovery_question.question", "error");
  console.log(`responseQuestion : ${responseQuestion}`);
  return !isEmpty(get(response, "recovery_question.question", ""));
};

const hasActiveFactors = (factors) =>
  !isEmpty(factors) &&
  factors.filter((f) => f.status === "ACTIVE" && f.factorType !== "question")
    .length > 0;

const hasNoFactors = (factors) =>
  isEmpty(factors) ||
  factors.filter((f) => f.factorType !== "question").length < 1;

const isPendingActivation = (factors) =>
  !isEmpty(factors) &&
  factors.filter((f) => f.status === "PENDING_ACTIVATION").length > 0;

function* handleSignIn(response) {
  // console.log("SIGN_IN action :", response);
  let factorStatus = yield select(factorStatusSelector);
  if (response.status === "SUCCESS" && factorStatus === "") {
    // console.log("Authenticated");
    let userGuid = response._embedded.user.id;
    return getFactors(userGuid);
  } else if (response.status === "LOCKED_OUT") {
    console.log("LOCKED_OUT");
    //TODO: get the locked out policy and show the maxAttempt/autoUnlocks /v1/policies?type=PASSWORD
  } else if (
    response.status === "PASSWORD_WARN" ||
    response.status === "PASSWORD_EXPIRED"
  ) {
    return push("/change-password");
  } else if (response.status === "MFA_REQUIRED") {
    return push("/mfa-authentication");
  } else if (response.status === "MFA_ENROLL") {
    // check if both factor
    const factors = yield select(mfaEnrollFactors);
    if (factors && factors == "both") {
      return push("/mfa-enroll-factor");
    } else return push("/mfa-enroll");
  }
}

function* handleOktaSession(response) {
  // console.log("OKTA SESSION action :", response);
  if (response.status === "ACTIVE") {
    console.log("Has Okta Session");
    return authorizeInOktaDirectly();
  } else {
    console.log("handleOktaSession not available - redirecting to login");
    return yield push("/login");
  }
}

function* handleOktaAuthorization(response) {
  // console.log("OKTA Authorize action :", response);
  if (response.status !== "SUCCESS") {
    console.log("handleOktaAuthorization failed- redirecting to login");
    return yield push("/login");
  }
}

function* handleSecurityQuestionStatus(response) {
  let user = yield select(userSelector);
  return yield authorize(LocalStoreService.getOidc(), user);
}

function* handleFactors(response) {
  let user = yield select(userSelector);
  const isPasswordExpired = yield select(isPasswordExpiredSelector);
  console.log(`handle factors Passwordexpired : ${isPasswordExpired}`);
  if (
    hasNoFactors(response) ||
    !hasActiveFactors(response) ||
    isPendingActivation(response) ||
    isPasswordExpired
  ) {
    return push("/multifactor");
  }
  return yield getQuestionStatus(get(user, "_embedded.user.id"));
}

function isTokenVerified(response) {
  console.log(response);
  return !isEmpty(response.stateToken);
}

actionMap.set(CHECK_OKTA_SESSION, handleOktaSession);
actionMap.set(AUTHORIZE_IN_OKTA, handleOktaAuthorization);
actionMap.set(SIGN_IN, handleSignIn);
actionMap.set(ENC_DATA_SIGN_IN, handleSignIn);
actionMap.set(CHANGE_PASSWORD, handleSignIn);
actionMap.set(GET_FACTORS, handleFactors);
actionMap.set(GET_QUESTION_STATUS, handleSecurityQuestionStatus);
actionMap.set(UPDATE_FACTOR, function* (response) {
  if (eq(get(response, "status", ""), "ACTIVE")) {
    let user = yield select(userSelector);
    return yield getQuestionStatus(get(user, "_embedded.user.id"));
  } else if (isEmpty(oktaErrorMessage({ data: response }))) {
    return push("/verify-multifactor", {
      factorType: response.factorType,
      parentPage: "/multifactor"
    });
  }
});

actionMap.set(PASSCODE_SUBMIT, function* (response) {
  let user = yield select(userSelector);
  return yield getQuestionStatus(get(user, "_embedded.user.id"));
});

actionMap.set(SKIP_FACTORS, function* () {
  let user = yield select(userSelector);
  return yield getQuestionStatus(get(user, "_embedded.user.id"));
});

actionMap.set(SET_SECURITY_QUESTION, function* (response) {
  let user = yield select(userSelector);
  if (isQuestionSetup(response)) {
    return yield authorize(LocalStoreService.getOidc(), user);
  } // Need to show error
});

actionMap.set(FORGOT_PASSWORD, function* (response, action) {
  if (
    response.status === "RECOVERY_CHALLENGE" &&
    response.factorType === "EMAIL"
  ) {
    return yield push("/email-confirmation", { resendData: action.data });
  }
  if (
    response.status === "RECOVERY_CHALLENGE" &&
    response.factorType === "SMS"
  ) {
    return yield push("/verify-multifactor", {
      recoveryType: response.recoveryType,
      factorType: response.factorType,
      parentPage: "/forgot-password"
    });
  }
});

actionMap.set(VERIFY_TOKEN, function* (response) {
  if (isTokenVerified(response)) {
    return yield push("/new-password");
  } else {
    return yield push("/");
  }
});

actionMap.set(RECOVERY_PASSCODE_SUBMIT, function* (response) {
  if (isTokenVerified(response)) {
    return yield push("/new-password");
  }
});

actionMap.set(RESEND_PASSWORD_RECOVERY_CODE, function* (response) {
  if (
    response.status === "RECOVERY_CHALLENGE" &&
    response.factorType === "SMS"
  ) {
    return yield push("/verify-multifactor", {
      recoveryType: response.recoveryType,
      factorType: response.factorType,
      parentPage: "/forgot-password"
    });
  }
});

actionMap.set(SUBMIT_ANSWER, function* (response) {
  if (isTokenVerified(response)) {
    return yield push("/new-password");
  }
});

actionMap.set(RESET_PASSWORD, function* (response) {
  if (eq(get(response, "status", ""), "SUCCESS")) {
    //TODO: We can initiate authorize call from here since we receive sessionToken in response
    return yield push("/");
  } else if (eq(get(response, "status", ""), "MFA_REQUIRED")) {
    return push("/mfa-authentication");
  }
});

actionMap.set(GET_LINKED_DMS, function* (response) {
  if (eq(get(response, "status", ""), "SUCCESS")) {
    return yield push("/federation");
  }
});

actionMap.set(CLEAN_UP, function* () {
  return yield cleanUp();
});

actionMap.set(DELETE_OKTA_SESSION, function* (response) {
  return yield push("/");
});

actionMap.set(CHECK_ENCDATA_TOKEN, function* (response) {
  const credentials = get(response, "credentials", "");
  if (!isEmpty(credentials)) {
    const decodedCredentials = atob(credentials).split(":");
    const emailId = decodedCredentials[0];
    const password = decodedCredentials[1];
    const oktaUser = isValidEmailForm(emailId)
      ? emailId
      : `${emailId}@connectcdk.com`;
    return encDataSignIn(oktaUser, password);
  } else {
    return yield push("/");
  }
});

actionMap.set(MFA_SELECT, function* (response) {
  if (
    eq(get(response, "status", ""), "MFA_CHALLENGE") &&
    eq(get(response, "factorResult", ""), "CHALLENGE")
  ) {
    return yield push("/mfa-auth-verification", {
      selectedFactorResonse: response
    });
  }
});

actionMap.set(MFA_VERIFY_FACTOR, function* (response) {
  if (!isEmpty(get(response, "sessionToken", ""))) {
    return yield authorize(LocalStoreService.getOidc(), response);
  } else if (
    response.status === "PASSWORD_WARN" ||
    response.status === "PASSWORD_EXPIRED"
  ) {
    return push("/change-password");
  }
});

actionMap.set(MFA_VERIFY_FACTOR_FIRST_TIME, function* (response) {
  if (!isEmpty(get(response, "sessionToken", ""))) {
    return yield authorize(LocalStoreService.getOidc(), response);
  } //check if user is enrolling single or both factors
  else if (
    !isEmpty(get(response, "stateToken", "")) &&
    response.status == "MFA_ENROLL"
  ) {
    //enroll second factor
    return yield push("/mfa-enroll-factor", {
      enrolledFactorResponse: response
    });
  } else if (
    response.status === "PASSWORD_WARN" ||
    response.status === "PASSWORD_EXPIRED"
  ) {
    return push("/change-password");
  }
});

actionMap.set(MFA_RESEND_CODE, function* (response) {
  return yield push("/mfa-auth-verification", {
    selectedFactorResonse: response
  });
});

actionMap.set(ENROLL_SPECIFIC_MFA, function* (response) {
  if (!isEmpty(get(response, "stateToken", ""))) {
    return yield push("/new-mfa-auth-verification", {
      selectedFactorResonse: response
    });
  }
});

export default function* service(action, response) {
  let actionCallback = actionMap.get(action.type);
  if (response && actionCallback && isFunction(actionCallback)) {
    return yield actionCallback(response, action);
  } else {
    console.error("Not implemented for action Type :", action.type);
  }
}
